const BID = 'bid';
const EMPLOYEE = 'employee';


export const WarningType = Object.freeze({
    [BID]: 0,
    [EMPLOYEE]: 1,

});

export const WarningTypeNames = Object.freeze({
    0: BID,
    1: EMPLOYEE,
});
